<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ویرایش درخواست مرخصی</h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>



            <div class="card card-style">
                <div class="content">
                    <div class="input-style input-style-2 has-icon input-required mb-3">
                        <i class="input-icon fa fa-check-square color-magenta2-light"></i>
                        <span class="color-highlight input-style-1-active">زمان درخواست</span>
                        <input class="form-control text-left" v-model="vacation.strVacationDate" readonly type="text">
                    </div>



                    <div v-if="isManager" class="input-style input-style-2 has-icon input-required mb-3">
                        <i class="input-icon fa fa-check-square color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : vacation.managerUserTitle!==null}">مدیر مربوطه</span>
                        <input class="form-control" v-model="vacation.managerUserTitle" readonly type="text">
                    </div>
                    <div v-if="isManager" class="input-style input-style-2 has-icon input-required mb-3">
                        <i class="input-icon fa fa-check-square color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : vacation.userTitle!==null}">درخواست کننده</span>
                        <input class="form-control" v-model="vacation.userTitle" readonly type="text">
                    </div>
                    <div v-if="isManager==false" class="d-flex mb-3">
                        <div class="w-100">
                            <v-select dir="rtl" v-model="vacation.managerUserId" label="mamager_Title" placeholder="مدیر مربوطه" :options="ManagerUserList" :reduce="p => p.mamager_LocalUserId">
                                <template v-slot="option">
                                    <div class="d-center">
                                        {{ option.mamager_Title }}
                                    </div>
                                </template>
                            </v-select>
                        </div>
                    </div>

                    <div class="d-flex mb-4">
                        <div class="w-100">
                            <v-select dir="rtl" v-model="vacation.vacationTypeId" label="title" placeholder="نوع مرخصی" :options="VacationTypeList" :reduce="p => p.vacationTypeId">
                                <template v-slot="option">
                                    <div class="d-center">
                                        {{ option.title }}
                                    </div>
                                </template>
                            </v-select>
                        </div>
                    </div>
                    <div class="row mx-0 mb-4">
                        <div class="col-6 pr-0">
                            <input class="form-check-input" type="radio" @change="changeLocalTypeRadio(0)" name="LocalTypeRid" id="LocalTypeRidD" value="0" checked>
                            <label class="form-check-label mx-4" for="LocalTypeRidD">
                                روزانه
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="radio" @change="changeLocalTypeRadio(1)" name="LocalTypeRid" id="LocalTypeRidH" value="1">
                            <label class="form-check-label mx-4" for="LocalTypeRidH">
                                ساعتی
                            </label>
                        </div>
                    </div>



                    <div>
                        <div class="input-style input-style-2 has-icon input-required mb-3">
                            <i class="input-icon fa fa-calendar-times color-magenta2-light"></i>
                            <span class="color-highlight input-style-1-active">{{fromDateTitle}}</span>
                            <input class="text-left" type="text" v-model="vacation.strFromDate" id="endDf" />
                        </div>
                        <date-picker type="date" v-model="vacation.strFromDate" format="jYYYY/jMM/jDD" element="endDf" />
                    </div>

                    <div class="mb-4" id="divTillDate">
                        <div class="input-style input-style-2 has-icon input-required mb-0">
                            <i class="input-icon fa fa-calendar-times color-magenta2-light"></i>
                            <span class="color-highlight input-style-1-active">تا تاریخ</span>
                            <input class="text-left" type="text" v-model="vacation.strTillDate" id="endDT" />
                        </div>
                        <date-picker type="date" v-model="vacation.strTillDate" format="jYYYY/jMM/jDD" element="endDT" />
                    </div>
                    <div id="divTime" class="">
                        <div class="mb-4">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <i class="fa fa-clock pl-2 color-magenta2-light"></i>
                                    <label class="mb-0 font-12 font-weight-bold">از ساعت</label>
                                </div>
                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <label class="mb-0 font-12 font-weight-bold w-50 text-center">دقیقه</label>
                                        <span class="font-13 font-weight-bold px-3"></span>
                                        <label class="mb-0 font-12 font-weight-bold w-50 text-center">ساعت</label>
                                    </div>
                                    <div class="ltr">
                                        <input placeholder="00" class="form-control ltr d-inline-block text-center" @input="() => { if(vacation.strFromTimeH > 23 || vacation.strFromTimeH < 0) { vacation.strFromTimeH = ''}}" style="max-width:60px" type="text" maxlength="2" max="23" v-model="vacation.strFromTimeH">
                                        <span class="font-13 font-weight-bold px-2">:</span>
                                        <input placeholder="00" @input="() => { if(vacation.strFromTimeM > 59 || vacation.strFromTimeM < 0) { vacation.strFromTimeM = ''}}" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="text" v-model="vacation.strFromTimeM">
                                        <!--<input placeholder="00" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskModel.suggestPersonTimeMinute" @change="saveHeader" @input="v$.taskModel.suggestPersonTimeMinute.$touch()" :class="{invalid:v$.taskModel.suggestPersonTimeMinute.$error}">-->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mb-4">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <i class="fa fa-clock pl-2 color-magenta2-light"></i>
                                    <label class="mb-0 font-12 font-weight-bold">تا ساعت</label>
                                </div>
                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <label class="mb-0 font-12 font-weight-bold w-50 text-center">دقیقه</label>
                                        <span class="font-13 font-weight-bold px-3"></span>
                                        <label class="mb-0 font-12 font-weight-bold w-50 text-center">ساعت</label>
                                    </div>
                                    <div class="ltr">
                                        <input placeholder="00" class="form-control ltr d-inline-block text-center" @input="() => { if(vacation.strTillTimeH > 23 || vacation.strTillTimeH < 0) { vacation.strTillTimeH = ''}}" style="max-width:60px" type="text" maxlength="2" max="23" v-model="vacation.strTillTimeH">
                                        <span class="font-13 font-weight-bold px-2">:</span>
                                        <input placeholder="00" @input="() => { if(vacation.strTillTimeM > 59 || vacation.strTillTimeM < 0) { vacation.strTillTimeM = ''}}" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="text" v-model="vacation.strTillTimeM">
                                        <!--<input placeholder="00" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskModel.suggestPersonTimeMinute" @change="saveHeader" @input="v$.taskModel.suggestPersonTimeMinute.$touch()" :class="{invalid:v$.taskModel.suggestPersonTimeMinute.$error}">-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="input-style input-style-2 has-icon input-required mb-0">
                            <i class="input-icon fa fa-calendar-times color-magenta2-light"></i>
                            <span class="color-highlight input-style-1-active">بازگشت به کار</span>
                            <input class="text-left" type="text" v-model="vacation.strReturnDate" id="endDR" />
                        </div>
                        <date-picker type="date" v-model="vacation.strReturnDate" format="jYYYY/jMM/jDD" element="endDR" />
                    </div>
                    <div class="input-style input-style-2 has-icon input-required mb-3">
                        <i class="input-icon fa fa-check-square color-magenta2-light"></i>
                        <span class="color-highlight input-style-1-active">جایگزین</span>
                        <input class="form-control" v-model="vacation.alternativePersonTitle" type="text">
                    </div>

                    <div class="card mx-0 mb-4">
                        <div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
                            <button data-toggle="collapse" data-target="#collapse-description">
                                <i class="fa fa-edit mt-2"></i>
                                <span>توضیحات</span>
                                <i class="fa fa-angle-down"></i>
                            </button>
                        </div>
                        <div class="collapse collapse-reminderCalendars" id="collapse-description">
                            <textarea v-model="vacation.description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px"></textarea>

                        </div>
                    </div>

                    <div class="input-style input-style-2 has-icon input-required mb-4">
                        <i class="input-icon fa fa-check-square color-magenta2-light"></i>
                        <span class="color-highlight input-style-1-active">وضعیت</span>
                        <select class="form-control" :disabled="isManager==false" v-model="vacation.status">
                            <option value="2">درحال بررسی</option>
                            <option value="3">تایید شده</option>
                            <option value="4">رد شده</option>
                        </select>
                    </div>

                    <div class="card mx-0 mb-4">
                        <div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
                            <button data-toggle="collapse" data-target="#collapse-ConfirmerDesc">
                                <i class="fa fa-edit mt-2"></i>
                                <span>توضیحات بررسی کننده</span>
                                <i class="fa fa-angle-down"></i>
                            </button>
                        </div>
                        <div class="collapse collapse-reminderCalendars" id="collapse-ConfirmerDesc">
                            <textarea :disabled="isManager==false" v-model="vacation.confirmerDesc" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px"></textarea>
                        </div>
                    </div>




                    <div class="input-style input-style-2 has-icon input-required mb-3">
                        <i class="input-icon fa fa-check-square color-magenta2-light"></i>
                        <span class="color-highlight input-style-1-active">زمان بررسی</span>
                        <input class="form-control text-left" v-model="vacation.strConfirmedDateTime" readonly type="text">
                    </div>
                    <button :disabled="msg" class="btn btn-xxs mt-2 btn-full bg-green1-dark rounded-sm font-900 w-100 btn_checkSmsm" @click.prevent="UpdateVacation">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
            <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
                <div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
                    <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import useVuelidate from '@vuelidate/core'
    import {
        required, between
    } from "@vuelidate/validators";
    import { maska } from 'maska';
    import DatePicker from 'vue3-persian-datetime-picker';
    import VueSimpleAlert from 'vue3-simple-alert';
    export default {
        components: {
            DatePicker
        },
        data() {
            return {
                fromDateTitle: "از تاریخ",
                pageLoading: true,
                msg: false,
                isManager: false,
                vacation: {
                    vacationId: null,
                    strVacationDate: null,
                    managerUserId: null,
                    managerUserTitle: null,
                    localType: 0,
                    status: null,
                    confirmerDesc: null,
                    statusTitle: null,
                    strConfirmedDateTime: null,
                    strFromDate: null,
                    strFromTime: null,
                    strFromTimeH: null,
                    strFromTimeM: null,
                    strTillDate: null,
                    strTillTime: null,
                    strTillTimeH: null,
                    strTillTimeM: null,
                    strReturnDate: null,
                    alternativePersonTitle: null,
                    description: null,
                    vacationTypeId: null
                },
                managerUser: [],
                vacationTypeList: [],
            }
        },
        methods: {
            UpdateVacation() {
                if (this.vacation.managerUserId == null) {
                    this.showErrorMessage("مدیر مربوطه را وارد کنید");
                    return;
                }
                if (this.vacation.vacationTypeId == null) {
                    this.showErrorMessage("نوع مرخصی را وارد کنید");
                    return;
                }
                if (this.vacation.strFromDate == null || this.vacation.strFromDate == "") {
                    this.showErrorMessage("از تاریخ را وارد کنید");
                    return;
                }
                if (this.vacation.strReturnDate == null || this.vacation.strReturnDate == "") {
                    this.showErrorMessage("بازگشت به کار را وارد کنید");
                    return;
                }
                if (this.vacation.strTillTimeH == null || this.vacation.strTillTimeH == "")
                    this.vacation.strTillTimeH = "00";
                if (this.vacation.strTillTimeM == null || this.vacation.strTillTimeM == "")
                    this.vacation.strTillTimeM = "00";

                if (this.vacation.strFromTimeH == null || this.vacation.strFromTimeH == "")
                    this.vacation.strFromTimeH = "00";
                if (this.vacation.strFromTimeM == null || this.vacation.strFromTimeM == "")
                    this.vacation.strFromTimeM = "00";

                this.vacation.strTillTime = this.vacation.strTillTimeH + ":" + this.vacation.strTillTimeM;
                this.vacation.strFromTime = this.vacation.strFromTimeH + ":" + this.vacation.strFromTimeM;

                this.pageLoading = true;
                this.msg = true;
                this.$http.post("Vacation/AddOrEditVacation", this.vacation)
                    .then(data => {
                        this.pageLoading = false;
                        this.msg = false;
                        var res = data.data;
                        if (res.isSuccess) {
                            this.showSuccessMessage(res.message);
                            this.goBack();
                        } else {
                            this.showErrorMessage(res.message);
                        }
                    });
            },
            changeLocalTypeRadio(localTypeVal) {
                this.vacation.localType = localTypeVal;
                this.vacation.strTillDate = null;
                document.getElementById("endDT").value = null;
                this.vacation.strTillTimeH = null;
                this.vacation.strTillTimeM = null;
                this.vacation.strFromTimeM = null;
                this.vacation.strFromTimeH = null;
                switch (parseInt(this.vacation.localType)) {
                    case 0:
                        document.getElementById("divTillDate").classList.add("d-none");
                        this.fromDateTitle = "از تاریخ";
                        document.getElementById("divTime").classList.add("d-none");
                        document.getElementById("divTillDate").classList.remove("d-none");
                        break;
                    case 1:
                        document.getElementById("divTime").classList.add("d-none");
                        this.fromDateTitle = " تاریخ";
                        document.getElementById("divTillDate").classList.add("d-none");
                        document.getElementById("divTime").classList.remove("d-none");
                        break;
                }
            },
            getManagerList() {
                this.$http
                    .get("Vacation/GetVacationManagerList")
                    .then((data) => {
                        var res = data.data;

                        this.managerUser = res

                    });
            },
            getVacationTypeList() {
                this.$http
                    .get("Vacation/GetVacationTypeList")
                    .then((data) => {
                        var res = data.data;

                        this.vacationTypeList = res

                    });
            },
            GetVacationItem() {
                this.pageLoading = true;
                this.msg = true;
                this.$http
                    .get("Vacation/GetById?Id=" + this.vacation.vacationId)
                    .then((data) => {
                        var res = data.data;
                        this.vacation = res;
                        this.isManager = res.isManager;
                        if (this.vacation.status == 0 || this.vacation.status == 1)
                            this.vacation.status = 2;
                        this.pageLoading = false;
                        this.msg = false;
                        if (res.msg != null && res.msg != "") {
                            this.msg = true;
                            this.showErrorMessage(res.msg);
                        }
                        switch (parseInt(this.vacation.localType)) {
                            case 0:
                                document.getElementById("LocalTypeRidD").checked = true;
                                document.getElementById("LocalTypeRidH").checked = false;
                                document.getElementById("divTillDate").classList.add("d-none");
                                this.fromDateTitle = "از تاریخ";
                                document.getElementById("theid");
                                document.getElementById("divTime").classList.add("d-none");
                                document.getElementById("divTillDate").classList.remove("d-none");
                                break;
                            case 1:
                                document.getElementById("LocalTypeRidD").checked = false ;
                                document.getElementById("LocalTypeRidH").checked = true;
                                document.getElementById("divTime").classList.add("d-none");
                                this.fromDateTitle = " تاریخ";
                        
                                document.getElementById("divTillDate").classList.add("d-none");
                                document.getElementById("divTime").classList.remove("d-none");
                                break;
                        }
              
                    });

            },

        },
        computed: {
            ManagerUserList() {
                return this.managerUser;
            },
            VacationTypeList() {
                return this.vacationTypeList;
            },

        },
        created() {
            this.$store.dispatch("CheckUserSMS");
            this.vacation.vacationId = this.$route.params.VacationId;
            this.getVacationTypeList();
            this.getManagerList();
            this.GetVacationItem();
        },
        mounted() {
            this.pageLoading = false;
            this.msg = false;
        },

    }
</script>